import { render, staticRenderFns } from "./sendPageCM.vue?vue&type=template&id=91efd848&"
import script from "./sendPageCM.vue?vue&type=script&lang=js&"
export * from "./sendPageCM.vue?vue&type=script&lang=js&"
import style0 from "./sendPageCM.vue?vue&type=style&index=0&id=91efd848&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports